import React from 'react';
import { IonButton, IonProgressBar } from '@ionic/react';

interface CycleDayReviewProps {
  currentDay: number;
  cycleLength: number;
  periodLength: number;
  lastPeriod: string;
  nextPeriodInDays: number;
  currentPhase: 'menstruation' | 'follicular' | 'ovulation' | 'luteal';
  onLogToday: () => void;
  hasCycleData: boolean;
}

const phaseLabels = { menstruation: 'Menstruation', follicular: 'Follicular', ovulation: 'Estimated ovulation', luteal: 'Luteal' } as const;

const CycleDayReview: React.FC<CycleDayReviewProps> = ({ currentDay, cycleLength, lastPeriod, nextPeriodInDays, currentPhase, onLogToday, hasCycleData }) => {
  if (!hasCycleData) return <section className="cycle-overview cycle-overview--empty"><div><span>Cycle overview · optional</span><h2>No cycle start logged yet</h2><p>Tap today or another date and mark a period day if you want cycle estimates. You can also use the calendar only for workouts and mood.</p></div><IonButton shape="round" fill="outline" onClick={onLogToday}>Log today</IonButton></section>;
  const safeDay = Math.max(1, Math.min(currentDay, cycleLength));
  return <section className="cycle-overview"><div className="cycle-overview__top"><div><span>Cycle overview · estimate</span><h2>Day {safeDay} of {cycleLength}</h2></div><b>{phaseLabels[currentPhase]}</b></div><IonProgressBar value={safeDay / cycleLength} /><div className="cycle-overview__details"><span><small>Next period</small>{nextPeriodInDays > 0 ? `In about ${nextPeriodInDays} days` : 'Estimate due'}</span><span><small>Last period</small>{lastPeriod}</span></div><p>Cycle estimates are approximate and not medical guidance.</p></section>;
};

export default CycleDayReview;
